var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        touchmove: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c("div", { staticClass: "img-counter" }, [
        _vm._v(_vm._s(_vm.activeIndex + 1) + "/" + _vm._s(_vm.imgUrls.length)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "close-btn", on: { click: _vm.handleClose } }, [
        _c(
          "svg",
          { attrs: { viewBox: "0 0 24 24", width: "24", height: "24" } },
          [
            _c("path", {
              attrs: {
                d: "M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12 5.7 16.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z",
                fill: "#fff",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { ref: "swiperContainer", staticClass: "swiper-container" }, [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.imgUrls, function (item, i) {
            return _c("div", { key: i, staticClass: "swiper-slide" }, [
              _c(
                "div",
                {
                  staticClass: "img-wrapper",
                  style: i === _vm.activeIndex ? _vm.imgWrapperStyle : "",
                  on: {
                    touchstart: function ($event) {
                      return _vm.onTouchStart($event, i)
                    },
                    touchmove: function ($event) {
                      return _vm.onTouchMove($event, i)
                    },
                    touchend: function ($event) {
                      return _vm.onTouchEnd($event, i)
                    },
                    click: function ($event) {
                      if ($event.target !== $event.currentTarget) return null
                      return _vm.handleClose.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: { src: item, draggable: "false" },
                    on: {
                      click: function ($event) {
                        return _vm.onImgClick($event, i)
                      },
                    },
                  }),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }